<template>
  <div class="dashboard-form-notifications">
    <h3>Dashboard Form Notifcations</h3>
  </div>
</template>

<script>

export default {
  name: 'DashboardFormNotifications',
  computed: {
    form () {
      return this.$store.getters['currentForm']
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/DashboardFormNotifications.vue